import validator from 'validator';

export const validarEmailVacio = (email) => {
  return new Promise((resolve, reject) => {
    // if (validator.isEmpty(email)) {
    //   resolve({ valido: false, mensaje: "El campo de email no puede estar vacío." });
    // } else 
    if (!validator.isEmail(email)) {
      resolve({ valido: false, mensaje: "El email no es válido." });
    } else {
      resolve({ valido: true });
    }
  });
};

export const validarEmail = (email) => {
  return new Promise((resolve, reject) => {
    if (email && !validator.isEmail(email)) {
      // Si el email no está vacío pero no es válido
      resolve({ valido: false, mensaje: "El email no es válido." });
    } else {
      // Si el email es válido o está vacío
      resolve({ valido: true });
    }
  });
};

export const validarSoloTexto = (texto) => {
  return new Promise((resolve, reject) => {
    if (validator.isEmpty(texto)) {
      resolve({ valido: false, mensaje: "El campo de texto no puede estar vacío." });
    } else if (!validator.isAlpha(texto, ['es-ES'], { ignore: " .'´`" })) {
      resolve({ valido: false, mensaje: "El texto solo puede contener letras." });
    } else {
      resolve({ valido: true, mensaje: '' });
    }
  });
};

export const validarTextoNumerico = async (texto) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚñÑ0-9\s.,-_'´`]+$/;

  // Permitir vacíos
  if (texto === "") {
    return { valido: true, mensaje: '' };
  }

  // Verificar contra el regex
  if (!regex.test(texto)) {
    return { valido: false, mensaje: "El texto solo puede contener letras, números, espacios y ciertos símbolos." };
  }

  return { valido: true, mensaje: '' };
};
export const validarPassword = async (password) => {
  if (validator.isEmpty(password)) {
    return { valido: false, mensaje: "El campo de contraseña no puede estar vacío." };
  } else if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!$%@#£€*?&.,;:]{8,}$|^\d{8,}$/.test(password)) {
    return { 
      valido: false, 
      mensaje: "La contraseña debe tener al menos 8 caracteres y contener letras y números." 
    };
  } else {
    return { valido: true, mensaje: '' };
  }
};

export const validarNumerico = async (numerico) => {
  if (validator.isEmpty(numerico)) {
    return { valido: false, mensaje: "El campo numérico no puede estar vacío." };
  } else if (!validator.isNumeric(numerico, { no_symbols: true })) {
    return { valido: false, mensaje: "El campo solo puede contener números." };
  } else if (parseInt(numerico) >= 1000000000000) {
    return { valido: false, mensaje: "El valor es demasiado grande." };
  } else if (parseInt(numerico) <= 0) {
    return { valido: false, mensaje: "El valor debe ser mayor que cero." };
  } else if (numerico[0] === '0') {
    return { valido: false, mensaje: "El valor no puede empezar con cero." };
  } else {
    return { valido: true, mensaje: '' };
  }
};

export const validarCodigoNumerico = async (numerico) => {
  if (validator.isEmpty(numerico)) {
    return { valido: false, mensaje: "El campo numérico no puede estar vacío." };
  } else if (!validator.isNumeric(numerico, { no_symbols: true })) {
    return { valido: false, mensaje: "El campo solo puede contener números." };
  } else if (parseInt(numerico) >= 999999) {
    return { valido: false, mensaje: "El valor es demasiado grande." };
  } else if (parseInt(numerico) <= 0) {
    return { valido: false, mensaje: "El valor debe ser mayor que cero." };
  } else {
    return { valido: true, mensaje: '' };
  }
};

export const validarTelefono = async (telefono) => {
  // if (validator.isEmpty(telefono)) {
  //   return { valido: false, mensaje: "El campo de teléfono no puede estar vacío." };
  // } else 
  if (!validator.isNumeric(telefono, { no_symbols: true })) {
    return { valido: false, mensaje: "El campo solo puede contener números." };
  } else if (telefono[0] === '0') {
    return { valido: false, mensaje: "El teléfono no puede comenzar con cero." };
  } else {
    return { valido: true, mensaje: '' };
  }
};

export const validarSelector = async (valor) => {
  if (valor === '' || valor === '0' || valor === 'null') {
    return { valido: false, mensaje: "Debe seleccionar una opción válida." };
  } else {
    return { valido: true, mensaje: '' };
  }
};